import React from 'react'

import {
  canSaveBudget,
  getBaseBudgetValue,
  getParsedBudgetValue,
} from './helpers'

interface UseTiktokBudgetHandlersParams {
  rate: number
  currencySymbol: string
  minBudget: number
  valueInput: number
  setValueInput: (value: number) => void
  setValueSlider: (value: number) => void
  savePrice: (value: number) => void
}

interface UseTiktokBudgetHandlersResult {
  handleSliderChange: (value: number) => void
  handleSliderChangeCompleted: (value: number) => void
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleInputBlur: () => void
}

export const useTiktokBudgetHandlers = ({
  rate,
  currencySymbol,
  minBudget,
  valueInput,
  setValueInput,
  setValueSlider,
  savePrice,
}: UseTiktokBudgetHandlersParams): UseTiktokBudgetHandlersResult => {
  const handleSliderChange = (value: number): void => {
    if (rate) {
      setValueInput(Math.round(value * rate))
    }
    setValueSlider(value)
  }

  const handleSliderChangeCompleted = (value: number): void => {
    savePrice(value)
  }

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    const parsedValue = getParsedBudgetValue(event.target.value, currencySymbol)
    if (parsedValue === null) {
      return
    }
    setValueInput(parsedValue)

    const baseValue = getBaseBudgetValue(parsedValue, rate)
    if (baseValue === null) {
      return
    }
    setValueSlider(baseValue)

    if (canSaveBudget(baseValue, minBudget)) {
      savePrice(baseValue)
    }
  }

  const handleInputBlur = (): void => {
    const baseValue = getBaseBudgetValue(valueInput, rate)
    if (baseValue !== null && baseValue < minBudget) {
      savePrice(minBudget)
    }
  }

  return {
    handleSliderChange,
    handleSliderChangeCompleted,
    handleInputChange,
    handleInputBlur,
  }
}
